/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Filter_Tags_AnyInputs */

const cs_clients_filter_tags_any = /** @type {(inputs: Clients_Filter_Tags_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Libovolný vybraný štítek`)
};

const en_clients_filter_tags_any = /** @type {(inputs: Clients_Filter_Tags_AnyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Any selected tag`)
};

/**
* | output |
* | --- |
* | "Any selected tag" |
*
* @param {Clients_Filter_Tags_AnyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_filter_tags_any = /** @type {((inputs?: Clients_Filter_Tags_AnyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Filter_Tags_AnyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_filter_tags_any(inputs)
	return cs_clients_filter_tags_any(inputs)
});